import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars
import {Icon} from '../../../common/components/Icon';

export const ContentFilterTable = ({content, title}) => {
    const check = <Icon name="checkmark-thin" style={{'font-size': '11px', 'color': '#36B372'}}/>;
    const x = <Icon name="x-mark-thin" style={{'font-size': '12px', 'color': '#FF6680'}}/>;

    return (
        <div className="responsive-table">
            <h3 className="table-title">{title}</h3>
            <table className="content-filters non-mobile-only" cellSpacing="0" cellPadding="0">
                <thead>
                    <tr>
                        <th className="non-mobile-only">DESCRIPTION</th>
                        <th className="cell-centered">G</th>
                        <th className="cell-centered">PG</th>
                        <th className="cell-centered">PG-13</th>
                        <th className="cell-centered">R</th>
                    </tr>
                </thead>
                <tbody>
                    {content.map( (row) => {
                        return (
                            <tr className='table-row'>
                                <td className="non-mobile-only">
                                    <div className="table-bold-text">{ row['description-title'] }</div>
                                </td>
                                <td className="cell-centered">
                                    { row.rating.includes('g') ? check : x }
                                </td>
                                <td className="cell-centered">
                                    { row.rating.includes('pg') ? check : x }
                                </td>
                                <td className="cell-centered">
                                    { row.rating.includes('pg13') ? check : x }
                                </td>
                                <td className="cell-centered">
                                    { row.rating.includes('r') ? check : x }
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {content.map( (row) => {
                return (
                    <table className="content-filters mobile-only" cellSpacing="0" cellPadding="0">
                        <thead>
                            <tr>
                                <th className="mobile-heading" colSpan={4}>DESCRIPTION</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan={4}>
                                    <div className="table-bold-text">{ row['description-title'] }</div>
                                </td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr>
                                <th className="cell-centered">G</th>
                                <th className="cell-centered">PG</th>
                                <th className="cell-centered">PG-13</th>
                                <th className="cell-centered">R</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="cell-centered">
                                    { row.rating.includes('g') ? check : x }
                                </td>
                                <td className="cell-centered">
                                    { row.rating.includes('pg') ? check : x }
                                </td>
                                <td className="cell-centered">
                                    { row.rating.includes('pg13') ? check : x }
                                </td>
                                <td className="cell-centered">
                                    { row.rating.includes('r') ? check : x }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                );
            })}
        </div>);
};
